import { FinnishSSNAnonymizer } from './plugins/FinnishSSNAnonymizer';
import { CardNumberAnonymizer } from './plugins/CardNumberAnonymizer';
/**
 * Default preprocessor plugins that are automatically added to every chat client.
 * These plugins handle common preprocessing tasks like data anonymization.
 */
export const defaultPlugins = [
    new FinnishSSNAnonymizer(),
    new CardNumberAnonymizer(),
];
//# sourceMappingURL=defaultPlugins.js.map